module.exports = __webpack_public_path__ + "media/images/close-0734d707627eca113b73173f06b01a2b.svg";